











































import { Vue, Component, Watch } from 'vue-property-decorator';
import { List, Dialog, Toast } from 'vant';
import moment from 'moment';
import openAppTip from '@/plugins/WxOpenAppTip';
import { getUserUploadHistory, delArticle } from '../api';

Vue.use(List).use(Dialog).use(Toast).use(openAppTip);

const host = 'https://wap.cqcb.com';

@Component
export default class User extends Vue {
  statusMarks = [
    {
      title: '审核中，请耐心等待',
      className: 'status-censoring',
    },
    {
      title: '审核通过',
      className: 'status-approved',
    },
    {
      title: '审核未通过，请上传符合要求的作品',
      className: 'status-deny',
    },
  ];
  list: any[] = [];
  finished = false;
  page = 1;
  loading = false;
  isApp = false;

  async created() {
    this.isApp = !!window.udid;
    window.userInfoChange = () => {
      location.reload();
    };
  }

  activated() {
    console.log('activated');
    this.checkUserLogin();
  }

  checkUserLogin() {
    const userLogin = window.gettoken() && window.gettoken() !== 'null';
    if (window.udid && !userLogin) {
      window.handleMessage('{"action":"mUserLogin","data":""}');
    }
  }

  async onGetUserUploadHistory() {
    if (this.finished) {
      return console.log('no more data');
    }
    this.loading = true;
    const ret = await getUserUploadHistory(this.page);
    this.loading = false;
    if (ret.data && ret.data.length) {
      this.page++;
      this.list = [
        ...this.list,
        ...ret.data.map((item: any) => ({
          ...item,
          created_at: moment(item.created_at * 1000).format('YYYY-MM-DD'),
        })),
      ];
    } else {
      this.finished = true;
    }
  }

  onNavToUpload() {
    const userLogin = window.gettoken() && window.gettoken() !== 'null';
    if (this.isApp && userLogin) {
      location.href = `${host}/shangyou_news/composition/contribute`;
    } else {
      this.$openAppTip();
    }
  }
  onJumpToDetail(data: any) {
    if (Number(data.status) !== 1) {
      return Toast('稿件暂未通过审核，请等待');
    }
    location.href = `${host}/shangyou_news/composition/compositionDetail?id=${data.id}`;
  }
  onDelete(data: any) {
    Dialog.confirm({
      message: '确认删除么？',
    })
      .then(async () => {
        // on confirm
        const ret: any = await delArticle(data.id);
        if (ret.code === 200) {
          Toast(ret.msg);
          setTimeout(() => {
            location.reload();
          }, 1000);
        }
      })
      .catch(() => {
        // on cancel
        console.log('user cancled');
      });
  }
}
